import type { CartItem as CartItemType } from '../types';
import { useCart } from '../context/CartContext';
import { useI18n, localizeField } from '../i18n';

interface CartItemProps {
  cartItem: CartItemType;
}

export function CartItemRow({ cartItem }: CartItemProps) {
  const { updateQuantity, removeItem } = useCart();
  const { lang } = useI18n();
  const addonTotal = cartItem.addons.reduce((s, a) => s + Number(a.price), 0);
  const lineTotal = (Number(cartItem.item.price) + addonTotal) * cartItem.quantity;

  return (
    <div className="hc-cart-item">
      <div className="hc-cart-item-info">
        <span className="hc-cart-item-name">{localizeField(cartItem.item.name_i18n, cartItem.item.name, lang)}</span>
        {cartItem.addons.length > 0 && (
          <span className="hc-cart-item-addons">
            {cartItem.addons.map((a) => a.name).join(', ')}
          </span>
        )}
        {cartItem.note && (
          <span className="hc-cart-item-note">{cartItem.note}</span>
        )}
      </div>
      <div className="hc-cart-item-controls">
        <div className="hc-qty-controls">
          <button
            className="hc-qty-btn"
            onClick={() => updateQuantity(cartItem.uid, cartItem.quantity - 1)}
          >
            &minus;
          </button>
          <span className="hc-qty-value">{cartItem.quantity}</span>
          <button
            className="hc-qty-btn"
            onClick={() => updateQuantity(cartItem.uid, cartItem.quantity + 1)}
          >
            +
          </button>
        </div>
        <span className="hc-cart-item-price">{lineTotal.toFixed(2)} &euro;</span>
        <button className="hc-cart-item-remove" onClick={() => removeItem(cartItem.uid)}>
          &times;
        </button>
      </div>
    </div>
  );
}
